import * as React from 'react';
import { TextButton } from 'wix-ui-tpa';
import { DEMO_CALENDARS_IDS } from '../../../constants';
import { classes } from './ExpandedLocation.st.css';
import LocationIcon from './LocationIcon';
var openLink = function (link) { return window.open(link); };
var ExpandedLocation = function (_a) {
    var isDetailsVisible = _a.isDetailsVisible, locationLink = _a.locationLink, location = _a.location, onLocationClick = _a.onLocationClick, calendarId = _a.calendarId;
    var _onLocationClick = function () {
        // openLink(`https://maps.google.com/maps?q=${location}`); // need to tix this on serverSide default.json "GOOGLE_MAP_URL": "https://maps.google.com/maps?q="
        openLink(locationLink);
        onLocationClick && onLocationClick();
    };
    var handleKeyUp = function (e) {
        if (e.key === 'Enter') {
            _onLocationClick();
        }
    };
    if (!isDetailsVisible && !DEMO_CALENDARS_IDS.includes(calendarId)) {
        return null;
    }
    return (React.createElement(React.Fragment, null, location && locationLink ? (React.createElement("div", { className: classes.LocationWrapper, tabIndex: 1, onKeyUp: handleKeyUp },
        React.createElement(LocationIcon, null),
        React.createElement(TextButton, { className: classes.Location, onClick: _onLocationClick }, location))) : null));
};
export default React.memo(ExpandedLocation);
//# sourceMappingURL=ExpandedLocation.js.map